export default [
    {
      path: '/notifications',
      component: () => import('../views/notifications/NotificationsList.vue'),
      meta: {
        title: 'screens.notifications.notificationList.pageTitle',
      },
    }
  ]